var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35776 0.175736C1.12345 -0.0585786 0.743547 -0.0585786 0.509232 0.175736C0.274917 0.41005 0.274917 0.78995 0.509232 1.02426L3.48497 4L0.509232 6.97574C0.274917 7.21005 0.274917 7.58995 0.509232 7.82426C0.743547 8.05858 1.12345 8.05858 1.35776 7.82426L4.3335 4.84853L7.30923 7.82426C7.54355 8.05858 7.92345 8.05858 8.15776 7.82426C8.39207 7.58995 8.39207 7.21005 8.15776 6.97574L5.18202 4L8.15776 1.02426C8.39207 0.78995 8.39207 0.41005 8.15776 0.175736C7.92345 -0.0585786 7.54355 -0.0585786 7.30923 0.175736L4.3335 3.15147L1.35776 0.175736Z",
    fill: "#434546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8b24cae67adcfe401c7f73e4808bc5e3.svg";
export { ForwardRef as ReactComponent };